import InternationalContactsList from "components/contacts/InternationalContactsList"
import React from "react"

const AllIntConsignees = () => {
  return (
    <InternationalContactsList
      type="receiver"
      pageTitle="International Receivers"
    />
  )
}

export default AllIntConsignees
